import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mobile-layout',
  templateUrl: './mobile-layout.component.html',
  styleUrls: ['./mobile-layout.component.scss']
})
export class MobileLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
